<template>
  <teleport to="body">
    <div v-if="open" class="fixed inset-0 z-[70] overflow-y-auto">
      <!-- Backdrop -->
      <div class="fixed inset-0 bg-black/50 transition-opacity" @click="$emit('cancel')"></div>

      <!-- Modal -->
      <div class="flex min-h-full items-center justify-center p-4 text-center">
        <div
          class="w-full max-w-md transform overflow-hidden rounded-lg bg-white dark:bg-gray-800 p-6 text-left align-middle shadow-xl transition-all relative"
          @click.stop
        >
          <div class="flex items-center gap-3 mb-4">
            <div
              class="flex-shrink-0 w-10 h-10 rounded-full bg-yellow-100 dark:bg-yellow-900/50 flex items-center justify-center"
            >
              <ExclamationTriangleIcon class="h-5 w-5 text-yellow-600 dark:text-yellow-400" />
            </div>
            <h3 class="text-lg font-medium leading-6 text-gray-900 dark:text-white">
              {{ title }}
            </h3>
          </div>

          <p class="text-sm text-gray-500 dark:text-gray-400 mb-6">
            {{ message }}
          </p>

          <div class="flex justify-end gap-3">
            <button
              type="button"
              @click="$emit('discard')"
              class="px-4 py-2 text-sm font-medium text-red-700 dark:text-red-400 bg-red-50 dark:bg-red-900/30 rounded-lg hover:bg-red-100 dark:hover:bg-red-900/50"
            >
              {{ discardLabel }}
            </button>
            <button
              type="button"
              @click="$emit('cancel')"
              class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
            >
              {{ cancelLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'

const props = defineProps({
  open: {
    type: Boolean,
    required: true
  },
  title: {
    type: String,
    default: 'Niet-opgeslagen wijzigingen'
  },
  message: {
    type: String,
    default:
      'Je hebt wijzigingen gemaakt die nog niet zijn opgeslagen. Weet je zeker dat je wilt sluiten?'
  },
  discardLabel: {
    type: String,
    default: 'Sluiten zonder opslaan'
  },
  cancelLabel: {
    type: String,
    default: 'Verder bewerken'
  }
})

const emit = defineEmits(['discard', 'cancel'])

// Handle Escape key
const handleKeydown = e => {
  if (e.key === 'Escape' && props.open) {
    emit('cancel')
  }
}

onMounted(() => {
  document.addEventListener('keydown', handleKeydown)
})

onUnmounted(() => {
  document.removeEventListener('keydown', handleKeydown)
})
</script>
